
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import AppMailTemplateEditor from "@/components/mail/MailTemplateEditor.vue";
import Vue from "vue";
import AppMailTemplatePropSelect from "./MailTemplatePropSelect.vue";
import { IEmailTemplate } from "@/utils/email-template";
import { GoTemplateDataRoot } from "@/utils/go-template-data-structure/root";

export default Vue.extend({
	data() {
		return {
			selectedLang: "nl-be",
			contentAsText: "",
			cursorPosition: 0,
			selectedText: "",
			subjectCursorPosition: 0,
			subjectCursorEnd: 0
		};
	},
	props: {
		value: {
			type: Object as () => IEmailTemplate,
			required: true
		},
	},
	computed: {
		subjectData():GoTemplateDataRoot{
			return this.value.getSubjectData();
		},
		contentData():GoTemplateDataRoot{
			return this.value.getContentData();
		}
	},
	watch: {
		value: {
			deep: true,
			immediate: true,
			handler() {
				this.recomputeSelectedText();
			}
		},
		selectedLang: {
			deep: true,
			immediate: true,
			handler() {
				this.recomputeSelectedText();
			}
		},

	},
	methods: {
		addImage(url:string){
			(this.$refs.editor as any).insertImage(url);
		},
		addProp(prop: string) {
			(this.$refs.editor as any).insertText(prop);
		},
		addLink(url:string, text:string){
			(this.$refs.editor as any).insertLink(text, url);
		},
		onContentUpdate(value: string) {
			if (this.value.IsHTML) {
				// Fix issue with lists in vue editor
				value = value.replaceAll(/<li>[\s\n]*<\/li>/g, "<li></li>");
				value = value.replaceAll(/<ol>[\s\n]*<li>/g, "<ol></ol>");
				value = value.replaceAll(/<\/li>[\s\n]*<\/ol>/g, "</li></ol>");
			}
			this.value.Content.Translations[this.selectedLang] = value;
			this.recomputeSelectedText();
		},
		recomputeSelectedText() {
			if (!this.value.Content.Translations) {
				this.selectedText = "";
				return;
			}
			let val = this.value.Content.Translations[this.selectedLang];
			if (val == null) {
				this.selectedText = "";
			} else {
				this.selectedText = val;
			}
		},
		onSubjectKeyUp(event:KeyboardEvent){
			let target = event.target;
			if (!target) return;
			let input = target as HTMLInputElement;
			this.setSubjectCursorPosition(input);
		},
		onSubjectMouseUp(event:MouseEvent){
			let target = event.target;
			if (!target) return;
			let input = target as HTMLInputElement;
			this.setSubjectCursorPosition(input);
		},
		setSubjectCursorPosition(input:HTMLInputElement){
			this.subjectCursorPosition = input.selectionStart || 0;
			this.subjectCursorEnd = input.selectionEnd || this.subjectCursorPosition;
		},
		addSubjectProp(prop: string) {
			let text = this.value.Subject.Translations[this.selectedLang] || "";
			let part1 = text.slice(0, this.subjectCursorPosition);
			let part2 = text.slice(this.subjectCursorEnd, text.length);
			this.value.Subject.Translations[this.selectedLang] = part1 + prop + part2;
			this.$forceUpdate();
		},
	},
	components: {
		AppCustomLangSelect,
		AppMailTemplatePropSelect,
		AppMailTemplateEditor
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
